/* KHERAJANI COMPUTERS v3 behaviour: product-card colour swatches, quick add, shopping assistant. Original, dependency-free. */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); }

  /* ---------- small toast (also read out by screen readers) ---------- */
  var toastEl, toastTimer;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'khc-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 3200);
  }

  /* Re-wrap a swatch's data-price value the same way the server-rendered markup wraps it:
     the AED glyph (first whitespace-delimited token) gets its own .khc-aed span so it keeps
     picking up the Dirham webfont/weight/line-height reset after a client-side price swap,
     instead of being dropped in as a bare text node. */
  function priceMarkup(raw) {
    var s = String(raw == null ? '' : raw);
    var m = s.match(/^(\S+)(\s*)([\s\S]*)$/);
    if (!m) return esc(s);
    return '<span class="khc-aed">' + esc(m[1]) + '</span>' + m[2] + esc(m[3]);
  }

  /* ---------- product cards: swatches (real variant image + deep link) and quick add ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-khc-sw]');
    if (b) {
      e.preventDefault();
      var card = b.closest('[data-khc-card]');
      if (!card) return;
      $$('[data-khc-sw]', card).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      var img = $('.khc-pcard__i1', card);
      var src = b.getAttribute('data-img');
      if (img && src) { img.removeAttribute('srcset'); img.src = src; img.alt = b.getAttribute('aria-label') || img.alt; }
      card.classList.remove('has-alt');
      var base = card.getAttribute('data-base') || '';
      var link = $('[data-khc-cardlink]', card);
      if (link && base) link.setAttribute('href', base + (base.indexOf('?') > -1 ? '&' : '?') + 'variant=' + b.getAttribute('data-vid'));
      var pr = $('[data-khc-price-orig]', card);
      if (pr && b.getAttribute('data-price')) pr.innerHTML = priceMarkup(b.getAttribute('data-price'));
      return;
    }
    var q = e.target.closest && e.target.closest('[data-khc-quick]');
    if (q) {
      e.preventDefault();
      if (q.disabled) return;
      var cart = $('cart-drawer');
      var can = cart && typeof cart.getSectionsToRender === 'function' && typeof cart.renderContents === 'function';
      var fd = new FormData();
      fd.append('id', q.getAttribute('data-khc-quick'));
      fd.append('quantity', '1');
      if (can) { fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; })); fd.append('sections_url', window.location.pathname); }
      q.disabled = true;
      fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd })
        .then(function (r) { return r.json(); })
        .then(function (state) {
          q.disabled = false;
          if (state.status) { toast(state.description || state.message || 'Could not add this item to the cart.'); return; }
          q.classList.add('is-done');
          setTimeout(function () { q.classList.remove('is-done'); }, 1500);
          if (can) cart.renderContents(state); else window.location = (window.routes && window.routes.cart_url) || '/cart';
        })
        .catch(function () { q.disabled = false; toast('Could not add this item to the cart.'); });
    }
  });
})();
